import { Box, Fade } from '@mui/material';
import { lazy, Suspense } from 'react';

// `IncProgress` inlines a ~97KB SVGator animation runtime. Load it as its own
// async chunk so it stays off the synchronous critical path (app boot, every
// lazy-route Suspense fallback, drawers). The existing 500ms Fade delay means
// the chunk lands before the spinner would ever become visible.
const IncProgress = lazy(
  () => import('../inc-progress/inc-progress.component'),
);

type CenteredProgressProps = {
  Progress?: React.ComponentType<any>;
  sx?: object;
};

const CenteredProgress = ({
  Progress = IncProgress,
  sx,
}: CenteredProgressProps) => {
  return (
    <Box
      sx={{
        position: 'static',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
        ...sx,
      }}
      data-testid="CenteredProgress"
    >
      <Fade in={true} style={{ transitionDelay: '500ms' }} timeout={1000}>
        <Box>
          <Suspense fallback={null}>
            <Progress />
          </Suspense>
        </Box>
      </Fade>
    </Box>
  );
};
export default CenteredProgress;
